<template>
    <div>
        <w-navbar :icon="'iconchevron-left'" :cvShow="true" :nav_title="'面试押题神器'" :right_btn_html="sortText" @mobileLeftBtn="pageBack" @mobileRightBtn="changeSortState"/>
        <div class="content"  ref="scroll">
            <div class="list" ref="content">
                <div v-for="(item,index) in list" :key="index">
                    <div class="left" v-if="item.type == 1">
                        <img src="./image/9.png"  alt="" class="avatar" />
                        <div class="main">  
                            <div class="username">Kevin (超级简历)</div>
                            <div class="text">{{item.text}}</div>
                        </div>
                    </div>
                    <div class="right" v-if="item.type == 2">
                        <div class="main">
                            <div class="username" >{{userData.name}}</div>
                            <div class="text" @click="tabCvs"><span style="text-decoration:underline">{{item.text}}</span><span class="iconfont iconbianji1" /></div>
                            
                        </div>
                        <img :src="userData.avatar_url" alt="" class="avatar" />
                    </div>
                    <div v-if="item.type == 3" class="card">
                        <img src="./image/1.png" alt=""  class="to-detail-img" />
                        <div class="card-buttom" @click="toDetail">开始预测</div>
                    </div>
                    <div v-if="item.type == 4" class="card">
                        <img src="./image/6.png" alt="" style="width: 100%; height: 181px" />
                        <div class="card-buttom to-buttom" @click="toService" >查看详情</div>
                    </div>
                </div>
            <div  :style="{height:  popupHeight + 'px'}" v-if="popupHeight"></div>

            </div>
        </div>
        <!-- 弹出层 -->
        <w-popup :state="actionSheetState" @handleClose="handleClose" :display="true">
            <div slot="content" class="action-sheet-container">

                <!-- 有简历 -->
                <div v-if="cvList.length && isLogin && !updateCv">
                    <div style="" class="title">
                        <img :src="userData.avatar_url" alt="" srcset="" class="avatar" style="margin-right:10px;" />
                        <div style="" class="cv-title">我想分析的简历是：</div>
                    </div>
                    <div v-for="(item, index) in cvList" :key="index" class='cv-list' @click="handleClose(index)">
                        <div class="cv-name">{{ item.cv_name }}</div>
                        <div class="cv-score">{{ item.score }}分</div>
                    </div>
                </div>
                <div  v-if="updateCv">
                    <div style="" class="title" >
                        <img :src="userData.avatar_url" alt="" srcset="" class="avatar" style="margin-right:10px;" />
                        <div style="" class="cv-title">现在去</div>
                    </div>
                    <div class='cv-btn-update' @click="toCvs">
                        <div class="cv-btn">完善简历</div>
                    </div>
                </div>
                <!-- 无简历 -->
                <div v-if="!cvList.length && isLogin && !isDel">
                    <div style="" class="title">
                        <img :src="userData.avatar_url" alt="" srcset="" class="avatar" style="margin-right:10px;" />
                        <div style="" class="cv-title">我想要</div>
                    </div>
                    <div v-if="!isView">
                        <div class='cv-list' @click="toCvs">
                            <div class="cv-btn">去写简历</div>
                        </div>
                        <div class='cv-list' @click="toImport">
                            <div class="cv-btn">一键导入已有简历</div>
                        </div>
                    </div>
                    <div v-if="isView">
                        <div class='cv-list' @click="againChooseTab">
                            <div class="cv-btn">重新选择简历测试</div>
                        </div>
                        <div class='cv-list' @click="toMyList">
                            <div class="cv-btn">查看答过的面试题</div>
                        </div>
                    </div>
                    
                </div>
                <!-- 未登录 -->
                <div v-if="!isLogin">
                    <div style="" class="title">
                        <div style="" class="cv-title">登录提示</div>
                    </div>
                    <div class="login-list" @click="toLoginWx" v-if="isWxMini || isWechatBrowser">
                        <div class="login-list-item"><img src="./image/15.png" alt="" srcset="" class="wx-img"><span class="login-btn-text">微信登录</span>
                        </div>
                        <div class="login-btn">微信登录</div>
                    </div>
                     <div class="login-list" @click="toLogin">
                        <div class="login-list-item"><img src="./image/16.png" alt="" srcset="" class="wx-img"><span class="login-btn-text">手机号</span>
                        </div>
                        <div class="phone-btn">手机登录</div>
                    </div>
                </div>
            </div>
        </w-popup>
    </div>
</template>

<script>
import WNavbar from "@/components/global/w-navbar";
import WPopup from "@/components/global/w-popup-copy";
import { componentsMixin } from "../../assets/js/mixin/components";
import { eventMixin, loginMixin, envMixin} from "../../assets/js/mixin/global";
import {setupWebViewJavascriptBridge, calcSize, updateJWT, toLogin} from '../../assets/js/utils';
import { userMixin} from "../../assets/js/mixin/user";
import Cookies from "js-cookie";
var moment = require('moment');
moment.locale('zh-cn'); 

export default {
    props: {
        state: {
            type: Boolean,
            default: false,
        },
        pageData: {
            type: Object,
            default: () => {
                return {};
            },
        },
        exportState: {
            type: Boolean,
            default: false,
        },
        // actionSheetState: {
        //     type: Boolean,
        //     default: true,
        // },
        actionSheetData: {
            type: Object,
            default: () => {
                return {};
            },
        },
        highlightIndex: {
            type: Number,
            default: 1,
        },
    },
    name: "hackathon-index",
    mixins: [componentsMixin, eventMixin, envMixin, loginMixin, userMixin],
    data() {
        return {
            list: [],
            cvList: [],
            actionSheetState: false,
            token: "",
            recent:{},
            isLogin:false,
            isView:false,
            updateCv:false,
            isDel:false,
            popupHeight:''
        };
    },
    created(){
        let { hostname } = window.location
        // Cookies.set('_r_b_t', window.location.href, {
        //     domain: `${ hostname.split('.')[1] }.${ hostname.split('.')[2] }`,
        //     path: '/',
        //     expires: moment()
        //         .add(30, 'd')
        //         .valueOf()
        // })
        let _t = Cookies.get("_t");
        if (this.$route.query.code && !_t ) {
            this.code = this.$route.query.code;
            this.wxLogin();
        }
    },
    async mounted() {
        this.getMyInfo();
        this.list.push({
            type: 1,
            text: "Hi 我是超级面试官 Kevin，我擅长帮人预测在面试中可能会遇到的提问，押题命中率高达 80%", 
        });
        let _t = Cookies.get("_t");
        if(_t){
            this.isLogin = true;
            await this.getHistory();
            if(this.recent.recent_cv_token){
                let timer = setTimeout(() => {
                    this.list.push({
                    type: 1,
                    text:
                        "上次你已经获取过一组面试押题了，现在需要我为你做什么呢？", 
                    });
                    this.isView = true;
                    let timer = setTimeout(()=>{
                            this.actionSheetState = true;
                    },2000)
                },1000)
            }else{
                // 获取在线简历
                await this.getOnlineCvData();
                this.isLogin = true;
            }
            
        }else{
            console.log('未登录');
            let timer = setTimeout(()=>{
                 this.isLogin = false;
                this.actionSheetState = true;
                 clearTimeout(timer);
            },2500)
           
        }
        
       
    },
    computed: {
        sortText() {
            return null;
        },
        cvAccountToken() {
            let _t = Cookies.get("_t");
            let tokenPayload = JSON.parse(window.atob(_t.split(".")[1]));
            return tokenPayload.User.c_t;
        },
        
    },
    watch: {
    },
    components: {
        WNavbar,
        WPopup,
    },

    updated: function () {
        let domArr = document.getElementsByClassName('action-sheet-container')[0];
        this.popupHeight = domArr ? domArr.offsetHeight : 0;
    },
    methods: {
        async getMyInfo(){
         let res = await this.getUserAccountInfo(this.cvAccountToken);
         console.log(res,"resre")
        },

        pageBack() {
            this.$router.back();
        },

        tabCvs(){
            this.list.splice(2);
                // setTimeout(() => {
            this.actionSheetState = true;
            // }, 1000);
            this.updateCv = false;
        },

        async changeSortState() {
        },

        handleClose(index) {
            console.log(index)
            if(!index && index !=0){
                return ;
            }
            this.actionSheetState = false;
            this.list.push({ type: 2, text: this.cvList[index].cv_name });
            this.token = this.cvList[index].token;
           
            // 简历小于60分   
            if(this.cvList[index].score < 60 ){
                setTimeout(()=>{
                    this.list.push({
                        type: 1, text: '检测到简历低于 60 分，在求职中处于劣势，建议完善简历后再来进行面试预测吧'
                    })
                },1500)
                setTimeout(()=>{
                    this.actionSheetState = true;
                    this.updateCv = true;
                    setTimeout(()=>{
                        this.scrollToBottom();
                    },0)
                },3500)
                return ;
            }

            // 简历大于60分
            setTimeout(() => {
                this.list.push({
                    type: 1,
                    text:
                        "OK，我会根据这份简历，帮你预测出面试中会遇到的提问，希望可以助你更高效地准备面试，准备好了吗？",
                });
                setTimeout(() => {
                        this.scrollToBottom();
                },0)
                setTimeout(() => {
                    this.list.push({
                        type: 3,
                        text:
                            "好的，根据简历，我会帮你预测出面试中会遇到的提问，希望可以助你更高效地准备面试", 
                            });
                    setTimeout(() => {
                        this.scrollToBottom();
                    },0)
                }, 2000);
            }, 2000);
        },

        // 跳转答题详情
        toDetail() {
            this.showToast("正在分析简历.....",3000);
            setTimeout(()=>{ this.$router.push({
                path: "/interview/detail?token=" + this.token,
            });},3500)
           
        },

        // 获取在线简历
        async getOnlineCvData() {
            let res = await this.$api.cv.getCvList({ page: 1, page_size: 20 });
            if (res.code === 1000 || res.code === 80139) {
                this.cvList = res.data.cvs;
                if(!res.data.total_count){
                    let timer = setTimeout(()=> {
                        this.list.push({
                            type: 1,
                            text:
                                "发现你还没有简历哦，我需要根据你的简历进行预测的，请先去创建一份简历再来吧", 
                        });
                        clearTimeout(timer);
                        setTimeout(() => {
                            this.actionSheetState = true;
                            this.updateCv = false;
                            this.isView = false;
                            this.isDel = false;
                        }, 2000);
                    },2000);
                }else{
                    let timer = setTimeout(()=>{
                        this.list.push({
                            type: 1,
                            text:
                                "为能得出比较准确的预测结果，需要根据你的简历进行分析，请先提交一份简历吧", 
                        });
                        clearTimeout(timer);
                        setTimeout(() => {
                        this.actionSheetState = true;
                        setTimeout(()=>{
                                this.scrollToBottom();
                        },0)
                        
                    }, 2000);
                    },1000)
                }
            }
        },

        // 
        async getQusList() {
            let res = await this.$api.hackathon.getQusList({
                cv_token: "jfHilsqw",
            });
            console.log(res, "getQusList");
        },

        // 获取第一次进去的消息
       async getHistory(){
            let res = await this.$api.hackathon.getHistory();
            if(res.code == 1000){
                this.recent = res.data;
                console.log(res.code);
            }
        },

        //微信登录
        wxLogin() {
            this.$api.hackathon.wxLogin({code: this.code,client: "wechat_mobile_browser"})
                .then( async res => {
                if (res.code == 1000) {
                    this.showToast("登录成功");
                    updateJWT({
                        jwt: res.data.jwt,
                        jwt_timestamp: res.data.jwt_timestamp
                    });
                    this.isLogin = true;
                    await this.getHistory();
                    window.location.reload();
            //         await this.getOnlineCvData();
            //         if(this.recent.recent_cv_token){
            //             let timer = setTimeout(() => {
            //                 this.list.push({
            //                 type: 1,
            //                 text:
            //                     "上次你已经获取过一组面试押题了，现在需要我为你做什么呢？", 
            //                 });
            //                 this.isView = true;
            //                 let timer = setTimeout(()=>{
            //                         this.actionSheetState = true;
            //                 },2000)
            //             },1000)
            //         }else{
            //             // 获取在线简历
            //             await this.getOnlineCvData();
            //             this.isLogin = true;
            // }
                }else{
                    console.log(res.message);
                }
            }).catch(err=>{
                console.log(err);
            });
        },
        toImport(){
             window.location.href ='/welcome/mobile_import_cv_index';
        },

        toLogin(){
            window.location.href = '/auth-signin?type=login&account_type=cv_account'
        },
        
        toLoginWx(){
            this.weChatAuthorization('snsapi_userinfo', window.location.href, 'login');
        },
        
        toMyList(){
            this.$router.push('/interview/my')
        },

        toService(){
            window.location.href = 'https://m.wondercv.com/service/'
        },
        toCvs(){
            this.$router.replace('/cvs')
        },
        againChooseTab(){
            this.list.splice(1);
            this.actionSheetState = false;
            this.getOnlineCvData();
        },
        scrollToBottom() {
            this.$nextTick(() =>{
                this.$refs.scroll.scrollTop = this.$refs.scroll.clientHeight ? this.$refs.scroll.clientHeight : 100 ;
            })
        }   
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global/variable";
@import "@/assets/scss/global/mixin";

 /deep/ .mobile-nav{
        background: #171c3c;
        border: none;
        color:#fff;
        /deep/ .nav-title {
            color: #fff !important;
        }
    }
.content::-webkit-scrollbar {
	width: 2px; /* 对纵向滚动条起作用*/
	height: 2px; /* 对横向滚动条起作用*/
	background: gray;
	display: none; /* 不显示滚动条 */
}

/* 滚动条最外面滑块样式 :: 前面保留一个空格*/
.content::-webkit-scrollbar-thumb {
	background: pink;
	border-radius: 2px;
	width: 2px; /* 对纵向滚动条起作用*/
	height: 2px; /* 对横向滚动条起作用*/
}
.content {
    background: rgba(23, 28, 60, 1);
    height: 100vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .cube-scroll-list-wrapper{
        min-height: 100% !important;
    }
    
    .w-popup .mask {
        display: none !important;
    }
     .list > :nth-last-child(2){
            margin-bottom: 50px;
        }
    .list {
        padding-top: 44px;
        margin-left: 16px;
        margin-right: 16px;
        animation: all 1s;
       
        .avatar{
            width:40px;height:40px;background:'#ff0';border-radius:50%;
        }
        .username{
            color: #9c9c9c;
            font-size: 12px;
            margin-bottom: 8px;
        }
        .to-detail-img{
            width: 100%; 
            height: 302px
        }
        .cv-title{
            font-size: 22px; 
            color: #404040;
            font-weight: bold;
        }
        .left {
            display: flex;
            width: 90%;
            margin-top: 46px;
            .main {
                flex: 1;
                margin-left: 10px;
                .text {
                    padding: 10px 16px;
                    color: #ffffff;
                    font-size: 16px;
                    background: rgba(46, 50, 78, 1);
                    line-height: 24px;
                    border-radius: 5px 10px 10px 10px;
                }
            }
        }
        .right {
            display: flex;
            width: 100%;
            margin-top: 46px;
            .iconbianji1{
                color:#56c380;
                margin-left: 8px;
            }
            .main {
                flex: 1;
                margin-left: 48px;
                margin-right: 10px;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                .text {
                    padding: 10px 16px;
                    color: rgba(69, 126, 234, 1);
                    font-size: 16px;
                    background: #fff;
                    line-height: 24px;
                    border-radius: 10px 2px 10px 10px;
                }
            }
        }
    }
   
}
 .action-sheet-container {
        width: calc(100vw - 20px);
        box-sizing: border-box;
        padding: 24px;
        max-height: 370px;
        overflow: auto;
        .cv-title{
            font-size: 22px; 
            color: #404040;
            font-weight: bold; 
        }
        .login-list{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 30px;
            .login-list-item{
                display: flex;
                align-items: center;
                .login-btn-text{
                    font-size: 14px;
                    font-weight: bold;
                    color: #404040;
                }
                .wx-img{
                    width: 40px;
                    height: 40px;
                    margin-right: 8px;
                }
            }
            .login-btn{
                width: 94px;
                height: 36px;
                background: #4BB64E;
                border-radius: 4px;
                color: #fff;
                text-align: center;
                line-height: 36px;
            }
            .phone-btn{
                width: 94px;
                height: 36px;
                background: #ECECEC;;
                border-radius: 4px;
                color: #606060;
                text-align: center;
                line-height: 36px;
            }
        }
        .avatar{
            width:40px;height:40px;background:'#ff0';border-radius:50%;
        }
        .title{
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            margin-bottom: 12px;
        }
        .cv-score{
            width: 43px;
            height: 24px;
            background: rgba(233, 91, 59, 0.1);
            border-radius: 2px;
            text-align: center;
            line-height: 24px;
            color: rgba(233, 91, 59, 1);
            margin-left: 11px;
            font-size: 12px;
        }
        .cv-name{
            font-size: 16px;
            color: #404040;
            white-space: nowrap;
            max-width: 216px;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .cv-btn{
            font-size: 16px;
            color: #404040;
            text-align: center;
            width: 100%;
        }
        .cv-btn-update{
            background-image: linear-gradient(to right, #FF9B56 , #FF6644);
            display: flex;
            align-items: center;
            padding: 16px;
            border-radius: 6px;
            margin-bottom: 12px;
            color: #fff;
            text-align: center;
            .cv-btn{
                text-align: center;
                color: #fff;
            }
        }
        .cv-list{
            display: flex;
            align-items: center;
            padding: 16px;
            background: #f0f5f6;
            border-radius: 6px;
            margin-bottom: 12px;
        }
        .action-sheet-content {
            padding: 0 28px;
            background-color: $color-light;
            border-radius: 10px;
            margin-bottom: 16px;
            .action-sheet-header {
                height: 48px;
                line-height: 48px;
                color: $color-light-gray;
                font-size: $font-size-small;
                @include ellipsis(100%);
            }
            .action-sheet-item {
                height: 55px;
                border-top: 1px solid #f9f9f9;
                font-size: $font-size-medium-x;
                color: $color-title;
            }
            .high-light-text {
                color: $color-theme;
            }
        }
        .action-sheet-cancel {
            background-color: $color-light;
            border-radius: 10px;
            height: 52px;
            font-size: $font-size-medium-x;
            color: $color-title;
            margin-bottom: 16px;
        }
        .w-popup .mask {
            display: none !important;
        }
    }
    .w-popup .mask {
        display: none !important;
}
@keyframes fade-in {
    0% {
        opacity: 0;
        transform: translate(0px, 20px);
    } /*初始状态 透明度为0*/
    40% {
        opacity: 0;
        transform: translate(0px, 20px);
    } /*过渡状态 透明度为0*/
    100% {
        opacity: 1;
        transform: translate(0px, 0px);
    } /*结束状态 透明度为1*/
}
@-webkit-keyframes fade-in {
    /*针对webkit内核*/
    0% {
        opacity: 0;
        transform: translate(0px, 20px);
    }
    40% {
        opacity: 0;
        transform: translate(0px, 20px);
    }
    100% {
        opacity: 1;
        transform: translate(0px, 0px);
    }
}
.left {
    animation: fade-in; /*动画名称*/
    animation-duration: 1.5s; /*动画持续时间*/
    -webkit-animation: fade-in 1.5s; /*针对webkit内核*/
}
.right {
    animation: fade-in; /*动画名称*/
    animation-duration: 1.5s; /*动画持续时间*/
    -webkit-animation: fade-in 1.5s; /*针对webkit内核*/
}
.card {
    margin-top: 46px;
    margin-bottom: 20px;
    position: relative;
     animation: fade-in; /*动画名称*/
    animation-duration: 0.5s; /*动画持续时间*/
    -webkit-animation: fade-in 0.5s; /*针对webkit内核*/
    .card-buttom {
        //   width: 300px;
        height: 44px;
        position: absolute;
        bottom: 20px;
        left: 50px;
        right: 50px;
        z-index: 9;
        background: #fff;
        border-radius: 1000000px;
        text-align: center;
        line-height: 44px;
        color: rgba(255, 102, 68, 1);
        font-size: 16px;
        font-weight: bold;
    }
    .card-buttom.to-buttom {
        left:24px;
        background:rgba(255, 102, 68, 1);
        width:175px;
        color:#fff;
        height:34px;
        line-height:34px
    }
}
</style>
